import { pickBy } from 'remeda';

import { MARKS } from '@@editor/constants';
import { Element } from '@@editor/helpers';
import { isUnityElement, isUnityTextItem } from '@@editor/typings/UnityElements';

import { type MarkRule } from '../types';

const marks = Object.values(MARKS);

const hasActiveMark = (elementOrNode = {}) =>
    Object.entries(elementOrNode).some(
        ([key, value]) => (marks as string[]).includes(key) && Boolean(value) === true,
    );

const pickMarks = (value, key) => !marks.includes(key) || Boolean(value) === true;

const markRules: MarkRule = {
    deserialize: (attributes): ReturnType<MarkRule['deserialize']> => {
        // By this exclusion, mark rules might be a bit to eager, but no way to identify them differently for now
        if (!isUnityElement(attributes) && !isUnityTextItem(attributes)) {
            if (hasActiveMark(attributes)) {
                return pickBy(attributes, pickMarks);
            }
        }
    },
    serialize: (node): ReturnType<MarkRule['serialize']> => {
        // By this exclusion, mark rules might be a bit to eager, but no way to identify them differently for now
        if (!Element.isElement(node)) {
            if (hasActiveMark(node)) {
                return pickBy(node, pickMarks);
            }
        }
    },
};

export default markRules;
